import { render, staticRenderFns } from "./BulkPayment.vue?vue&type=template&id=68038fe4&scoped=true"
import script from "./BulkPayment.vue?vue&type=script&lang=js"
export * from "./BulkPayment.vue?vue&type=script&lang=js"
import style0 from "./BulkPayment.vue?vue&type=style&index=0&id=68038fe4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68038fe4",
  null
  
)

export default component.exports